<template>
  <v-dialog v-model="dialog"
            persistent
            width="90%">
    <v-form @submit.prevent="submit">
      <v-card flat
              tile>
        <ShareTemplateCustomTagForm :form="form"
                                    :template="template">
        </ShareTemplateCustomTagForm>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy || isFormValid === false">
            Save
          </v-btn>

          <v-btn @click.prevent="close"
                 text>
            Cancel
          </v-btn>

          <template v-if="customTag">
            <v-spacer></v-spacer>
            <v-btn @click.prevent="deleteCustomTag"
                   color="error"
                   :disabled="form.busy">
              Delete
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import ShareTemplateCustomTagForm from './ShareTemplateCustomTagForm.vue';
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import DOMPurify from 'dompurify';

export default {
  components: {ShareTemplateCustomTagForm},
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    template: {
      type: Object,
      required: true,
    },
    customTag: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: new Form(shareTemplateService.initCustomTagForm(this.template.id, this.customTag)),
    }
  },
  computed: {
    isFormValid() {
      if (!this.form.template_id) {
        return false;
      }
      if (!this.form.name) {
        return false;
      }
      if (!this.form.tag_type) {
        return false;
      }
      //return this.form.options.length !== 0;
      return true;
    }
  },
  created() {
    console.log('ShareTemplateCustomTagDialog created for template', this.template.id, this.customTag);
  },
  methods: {
    submit() {
      if (this.customTag) {
        return shareTemplateService.updateCustomTag(this.customTag.id, this.form)
          .then(data => {
            this.$toast.success('Custom tag updated.');
            this.close();
          })
          .catch(err => {
            this.form.handleErrors(err);
            if (err.response?.data?.message) {
              this.$toast.error(DOMPurify.sanitize(err.response.data.message))
            }
          })
          .finally(() => {
            this.form.busy = false;
          })
      } else {
        this.form.startProcessing();
        return shareTemplateService.createCustomTag(this.form.data())
          .then(data => {
            this.form.finishProcessing();
            this.$toast.success('Custom tag created.');
            this.close();
          })
          .catch(err => {
            this.form.handleErrors(err);
          })
          .finally(() => {
            this.form.busy = false;
          })
      }
    },
    async deleteCustomTag() {
      if (confirm(`Are you sure you want to delete this custom tag?`)) {
        return shareTemplateService.deleteCustomTag(this.customTag.id)
          .then(data => {
            this.$toast.success('Custom tag deleted.');
            this.close();
          })
          .catch(err => {
            this.form.handleErrors(err);
          })
      }
    },
    close() {
      this.$emit('close');
    },
  }
}
</script>
